// extracted by mini-css-extract-plugin
export default {"switch":"switch_switch__t4dNy"};